module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-43.3a894b10.png";